export const FETCH_USERS_GROUPS_REQUEST = 'FETCH_USERS_GROUPS_REQUEST';
export const FETCH_USERS_GROUPS_SUCCESS = 'FETCH_USERS_GROUPS_SUCCESS';
export const FETCH_USERS_GROUPS_FAILED = 'FETCH_USERS_GROUPS_FAILED';

export const RESET_UPDATE_USER_GROUP = 'RESET_UPDATE_USER_GROUP';
export const CHANGE_POSITION = 'CHANGE_POSITION';
export const RESET_ONBOARDING = 'RESET_ONBOARDING';
export const SET_EXIT = 'SET_EXIT';

export const FETCH_CREATE_USER_GROUP_REQUEST = 'FETCH_CREATE_USER_GROUP_REQUEST';
export const FETCH_CREATE_USER_GROUP_SUCCESS = 'FETCH_CREATE_USER_GROUP_SUCCESS';
export const FETCH_CREATE_USER_GROUP_FAILED = 'FETCH_CREATE_USER_GROUP_FAILED';

export const FETCH_USER_GROUP_BY_ID_REQUEST = 'FETCH_USER_GROUP_BY_ID_REQUEST';
export const FETCH_USER_GROUP_BY_ID_SUCCESS = 'FETCH_USER_GROUP_BY_ID_SUCCESS';
export const FETCH_USER_GROUP_BY_ID_FAILED = 'FETCH_USER_GROUP_BY_ID_FAILED';

export const UPDATE_STEPS_LISTS_REQUEST = 'UPDATE_STEPS_LISTS_REQUEST';
export const UPDATE_STEPS_LISTS_SUCCESS = 'UPDATE_STEPS_LISTS_SUCCESS';
export const UPDATE_STEPS_LISTS_FAILED = 'UPDATE_STEPS_LISTS_FAILED';

export const FETCH_ADD_ITEM_TO_USER_GROUP_REQUEST = 'FETCH_ADD_ITEM_TO_USER_GROUP_REQUEST';
export const FETCH_ADD_ITEM_TO_USER_GROUP_SUCCESS = 'FETCH_ADD_ITEM_TO_USER_GROUP_SUCCESS';
export const FETCH_ADD_ITEM_TO_USER_GROUP_FAILED = 'FETCH_ADD_ITEM_TO_USER_GROUP_FAILED';

export const DELETE_USER_GROUP_REQUEST = 'DELETE_USER_GROUP_REQUEST';
export const DELETE_USER_GROUP_SUCCESS = 'DELETE_USER_GROUP_SUCCESS';
export const DELETE_USER_GROUP_FAILED = 'DELETE_USER_GROUP_FAILED';
export const RESET_DELETE_USER_GROUP = 'RESET_DELETE_USER_GROUP';

export const FETCH_REMOVE_PARENT_FROM_USER_GROUP_REQUEST =
  'FETCH_REMOVE_PARENT_FROM_USER_GROUP_REQUEST';
export const FETCH_REMOVE_PARENT_FROM_USER_GROUP_SUCCESS =
  'FETCH_REMOVE_PARENT_FROM_USER_GROUP_SUCCESS';
export const FETCH_REMOVE_PARENT_FROM_USER_GROUP_FAILED =
  'FETCH_REMOVE_PARENT_FROM_USER_GROUP_FAILED';
